import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getItemDropdown = createAsyncThunk(
    '/user/get-item-dropdown',
    async () => {
        try {
            const myurl = `${V_URL}/prosafe/get-items`;
            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const item = response.data;

            if (item.success === true) {
                return item;
            } else {
                throw new Error(item);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getItemDropdownSlice = createSlice({
    name: "getItemDropdown",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getItemDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getItemDropdown.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getItemDropdown.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getItemDropdownSlice.reducer;